import { useState } from "react";
import { DialogActions, DialogContent, DialogTitle, Divider, Grid } from "@mui/material";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useTranslation } from "react-i18next";
import { convertToJalali } from "../../../../utils/date";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import view components
import { AccommodationOrderContent } from "./accommodation-orders";
import OrderRooms from "./order-rooms";
import AccommodationPdf from "./accommodation-pdf-file";
import IntAccommodationPdf from "./int-accommodation-pdf-file";

//import images and icons
import { Add } from "iconsax-react";

function AccommodationDetailsModalContent({ selectedOrderItem, handleClose }) {
    //general variables
    const [parent] = useAutoAnimate();
    const { t } = useTranslation();

    //handle click on the cancellation request button
    const [isCancellationRequest, setIsCancellationRequest] = useState(false);

    return (
        <>
            <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
                <Grid container item xs={12} columnGap={1} alignItems="center">
                    <span className={`orders__label orders__label--${selectedOrderItem?.get_status?.en}`}>{selectedOrderItem?.get_status?.fa}</span>
                    <span className="orders__label orders__label--date">
                        {t("General.Order Date")}: {convertToJalali(selectedOrderItem?.create_date)}
                    </span>
                    <span className="orders__label orders__label--tracking-code">
                        {t("trackingCode")}: {selectedOrderItem?.tracking_code}
                    </span>
                </Grid>
                <Add className="close" size="32" color="var(--teal-color-18)" onClick={handleClose} cursor="pointer" />
            </DialogTitle>

            <DialogContent dividers={true}>
                <Grid container item xs={12} rowGap={3} direction="column">
                    <AccommodationOrderContent orderItem={selectedOrderItem} />

                    <Divider width="100%" />

                    <OrderRooms orderItem={selectedOrderItem?.accommodation} isCancellationRequest={isCancellationRequest} />
                </Grid>
            </DialogContent>

            <DialogActions ref={parent}>
                <Grid className="order-details-modal__download" container item md={2}>
                    <PDFDownloadLink
                        document={
                            selectedOrderItem.accommodation.is_foreign ? (
                                <IntAccommodationPdf orderItem={selectedOrderItem} />
                            ) : (
                                <AccommodationPdf orderItem={selectedOrderItem} />
                            )
                        }
                        fileName={`ticket_id_.pdf`}
                    >
                        {({ blob, url, loading, error }) => (
                            <BaseButton
                                text={`${t("download")} PDF`}
                                color="secondary"
                                radius="radius-10"
                                size="medium"
                                loading={loading}
                                disabled={selectedOrderItem?.get_status?.id !== 8}
                            />
                        )}
                    </PDFDownloadLink>
                </Grid>
                {isCancellationRequest ? (
                    <>
                        <Grid container item md={2}>
                            <BaseButton
                                text={t("General.Cancellation")}
                                color="outline-red"
                                size="medium"
                                radius="radius-10"
                                handleClick={() => setIsCancellationRequest(false)}
                            />
                        </Grid>
                        <Grid container item md={2}>
                            <BaseButton text={t("confirmation")} color="red" size="medium" radius="radius-10" />
                        </Grid>
                    </>
                ) : (
                    <Grid container item md={2}>
                        <BaseButton
                            text={t("General.Cancellation Request")}
                            color="red"
                            size="medium"
                            radius="radius-10"
                            handleClick={() => setIsCancellationRequest(true)}
                            disabled={selectedOrderItem?.get_status?.id !== 8}
                        />
                    </Grid>
                )}
            </DialogActions>
        </>
    );
}

export default AccommodationDetailsModalContent;
